import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import type Employee from 'modules/employees/store/models/Employee'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import BasicInformation from './BasicInformation'

export interface Props {
  employee: Employee
  planningVersion: PlanningVersion
  canAssignEmployees: boolean
  canManageCompanySchedules: boolean
}

const Content = ({
  employee,
  planningVersion,
  canAssignEmployees,
  canManageCompanySchedules,
}: Props) => {
  const { value: canEdit, loading } = useAsyncCan('planning_versions.edit', employee)
  const editable = canEdit && !planningVersion.isDefault

  if (loading) {
    return (
      <Box alignItems="center" width="full" padding="s32">
        <Spinner />
      </Box>
    )
  }

  return (
    <BasicInformation
      employee={employee}
      planningVersion={planningVersion}
      canEdit={editable}
      canAssignEmployees={canAssignEmployees}
      canManageCompanySchedules={canManageCompanySchedules}
    />
  )
}

export default observer(Content)
